import { Grid, Typography } from "@mui/material";
import { useLocation, useLocationState, useNavigate } from "../utils/Router";
import * as Yup from "yup";
import { FormProvider, RHFTextField } from "../common/hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { apiConstants, postGeneric } from "../common/constants";
import { useFormData } from "../utils/formDataProvider";
import { useResponse } from "../utils/itemDataProvider";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";

function OtpForm() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { awbNumber, phoneNumber } = useFormData();
    const { navigate } = useNavigate();
    const { setResponse } = useResponse();
    const { enqueueSnackbar } = useSnackbar();
    const locationState = useLocationState();

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                otp: Yup.string().required("OTP is required!")
            })
        ),
        defaultValues: {
            otp: '',
        },
    });
    const { handleSubmit } = methods;
    const onSubmit = (data) => {
        setIsSubmitting(true)
        const payload = {
            "awbNumber": awbNumber,
            "phoneNumber": phoneNumber,
            "otp": data.otp,
            "tokenId": locationState
        }
        postGeneric(`${apiConstants.VERIFY_OTP}`, payload).then((res) => {
            setIsSubmitting(false)
            setResponse(res.data);
            navigate('/items')
        }).catch((err) => {
            setIsSubmitting(false)
            console.log(err);
            enqueueSnackbar(err?.response?.data?.message || "Some error occurred!", { variant: 'error' })
        })
    }


    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ mb: 2 }}>
                    <Typography variant="h6" fontWeight={500}>
                        Verify OTP
                    </Typography>
                    <Typography variant="body2">
                        Enter OTP sent on phone number
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <RHFTextField
                        label="Enter OTP"
                        name="otp"
                        autoFocus
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        loading={isSubmitting}
                        type="submit"
                        fullWidth
                        variant="contained"
                        size="medium"
                    >
                        Next
                    </LoadingButton>
                </Grid>
            </Grid>
        </FormProvider>
    );
}

export default OtpForm;
